import PropTypes from "prop-types";
import React from "react";
import { page as pageIndex } from "../../../globals";
import STSComponent from "../../STSComponent/STSComponent";
import RadioButtons from "../RadioButtons/RadioButtons";
import "./css/Checkboxes.scss";

const customRegionStyles = {
  marginLeft: 23,
};

class CheckboxesList extends STSComponent {
  constructor(props) {
    super(props);
    this.getRadioData = this.getRadioData.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return (
      JSON.stringify(nextProps.values) !== JSON.stringify(this.props.values) ||
      JSON.stringify(nextProps.fieldData) !==
      JSON.stringify(this.props.fieldData) ||
      JSON.stringify(nextProps.location) !== JSON.stringify(this.props.location)
    );
  }

  getRadioData = (id, name) => {
    this.props.sendData(id, name);
  };

  renderList = () => {
    const {
      location,
      fieldData,
      updateData,
      undoTrackData,
      values,
      fieldId,
      page,
      openModal,
      isEdited,
      noBoxes,
      readOnly,
      isHistoryUndoEnabled, 
    } = this.props;
    const disabledValues = Array.isArray(values.disabled) ? values.disabled : [];
    return fieldData.map((item, i) => {
      // // hide if disabled. 
      // if (disabledValues.includes(item.id)){
      //   return <span></span>;
      // }

      // classname to identify changed (undo) values.       
      let isChangedClass = "";
      if (undoTrackData && undoTrackData.history){
        isChangedClass = undoTrackData.history.find(
          (elem) => elem.valueID === item.id
        ) ? "input-changed" : "";
      } 
      let isDisabledClass = "";
      if (disabledValues.includes(item.id)){
        isDisabledClass = "disabled";
      }
      switch (item.type) {
        case "ch_with_child":
          return (
            <div key={i}>
              <CheckboxRow
                isSelected={values.selected.includes(item.id)}
                itemData={item}
                location={location}
                updateData={updateData}
                noBoxes={noBoxes}
                readOnly={readOnly}
                isHistoryUndoEnabled={isHistoryUndoEnabled}        
              />
              {item.locality.map((elem, i) => {
                return (
                  <CheckboxRow
                    isSelected={values.selected.includes(elem.id)}
                    itemData={elem}
                    location={location}
                    updateData={updateData}
                    key={i}
                    child
                    noBoxes={noBoxes}
                    readOnly={readOnly}
                    isHistoryUndoEnabled={isHistoryUndoEnabled}
                  />
                );
              })}
            </div>
          );
        case "checkbox":
          return (
            <CheckboxRow
              key={i}
              isSelected={values.selected.includes(item.id)}
              itemData={item}
              location={location}
              updateData={updateData}
              undoTrackData={undoTrackData}
              noBoxes={noBoxes}
              readOnly={readOnly}              
              isHistoryUndoEnabled={isHistoryUndoEnabled}
              className={`${isChangedClass} ${isDisabledClass}`}
            />
          );
        case "checkbox_selectall":
          return (
            <CheckboxRow
              key={i}
              isSelected={values.selected.includes(item.id)}
              itemData={item}
              location={location}
              updateData={updateData}
              noBoxes={noBoxes}
              readOnly={readOnly}
              isHistoryUndoEnabled={isHistoryUndoEnabled}
            />
          );
        case "any_cb":
          return (
            <CheckboxRow
              key={i}
              isSelected={values.selected.length === 0}
              itemData={item}
              type={item.type}
              location={location}
              updateData={updateData}
              noBoxes={noBoxes}
              readOnly={readOnly}
              isHistoryUndoEnabled={isHistoryUndoEnabled}
            />
          );
        case "any_cb_with_uncheck":
          return (
            <CheckboxRow
              key={i}
              isSelected={values.selected.length === 0}
              itemData={item}
              type={item.type}
              location={location}
              updateData={updateData}
              noBoxes={noBoxes}
              readOnly={readOnly}
              isHistoryUndoEnabled={isHistoryUndoEnabled}
            />
          );
        case "ch_one":
          return (
            <CheckboxRow
              key={i}
              isSelected={values.selected.includes(item.id)}
              itemData={item}
              type={item.type}
              location={location}
              updateData={updateData}
              noBoxes={noBoxes}
              readOnly={readOnly}
              isHistoryUndoEnabled={isHistoryUndoEnabled}
            />
          );
        case "radio":
          return (
            <RadioButtons
              data={item.values}
              location={location}
              selected={values.radio[item.id]}
              key={i}
              id={item.id}
              styles={item.childrenStyles}
              icon={item.icons}
              input={item.input}
              page={page}
              updateData={updateData}
              editRadio={item.editRadio}
              sendData={this.getRadioData}
              readOnly={readOnly}
            />
          );
        case "text":
          return (
            <span
              key={i}
              style={item.childrenStyles}
              className="default-title-font"
            >
              {item.text}
            </span>
          );
        case "checkbox-with-descr":
          return (
            <div key={i}>
              <CheckboxRow
                isSelected={values.selected.includes(item.id)}
                itemData={item}
                type={item.type}
                location={location}
                updateData={updateData}
                noBoxes={noBoxes}
                readOnly={readOnly}
                isHistoryUndoEnabled={isHistoryUndoEnabled}
              />
              <span className="cb-description" style={item.descriptionStyles}>
                {item.description}
              </span>
            </div>
          );
        case "checkbox-hide-others":
          return (
            <CheckboxRow
              key={i}
              isSelected={values.radio[fieldId] === item.id}
              type={item.type}
              itemData={item}
              fieldId={fieldId}
              location={location}
              updateData={updateData}
              noBoxes={noBoxes}
              readOnly={readOnly}
              isHistoryUndoEnabled={isHistoryUndoEnabled}
            />
          );
        case "checkbox-exclude-others":
          return (
            <CheckboxRow
              key={i}
              isSelected={values.selected.includes(item.id)}
              type={item.type}
              itemData={item}
              fieldId={fieldId}
              location={location}
              updateData={updateData}
              open={openModal}
              isEdited={isEdited}
              noBoxes={noBoxes}
              readOnly={readOnly}
              isHistoryUndoEnabled={isHistoryUndoEnabled}
            />
          );
      }
    });
  };

  render() {
    return (
      <div className="checkboxes-field">
        <div
          className={`${
            this.props.horizontalOrder ? "d-flex" : ""
          } first-level`}
        >
          {this.renderList()}
        </div>
      </div>
    );
  }

  static propTypes = {
    location: PropTypes.object.isRequired,
    fieldData: PropTypes.array.isRequired,
    values: PropTypes.object.isRequired,
    updateData: PropTypes.func,
    fieldId: PropTypes.string,
    page: PropTypes.string,
    openModal: PropTypes.func,
    isEdited: PropTypes.bool,
    sendData: PropTypes.func,
    noBoxes: PropTypes.bool,
    readOnly: PropTypes.bool,
    horizontalOrder: PropTypes.bool,
  };
}

class CheckboxRow extends STSComponent {
  constructor(props) {
    super(props);
    this.updateDataValue = this.updateDataValue.bind(this);
    this.returnPermissionsModal = this.returnPermissionsModal.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.isSelected !== this.props.isSelected;
  }

  updateDataValue = () => {
    const { updateData, location, itemData, isSelected, fieldId, isHistoryUndoEnabled } = this.props;
    const valueType = isSelected ? "ch_uncheck" : "ch";
    const type = itemData.type;
    switch (type) {
      case "checkbox-hide-others":
        this.updateData(location, "ch_hide-others", itemData.id, fieldId);
        break;
      case "any_cb":
        this.updateData(location, "ch_uncheckall", itemData.id);
        break;
      case "ch_with_child":
        let valArr = [];
        for (let i = 0; i < itemData.locality.length; i++) {
          valArr[i] = itemData.locality[i].id;
        }
        valArr = [itemData.id, ...valArr];
        this.updateData(location, "ch_with_child", valArr);
        break;
      case "children":
        this.updateData(location, "children", itemData.id);
        break;
      case "checkbox_selectall":
        this.updateData(location, "checkbox_selectall", itemData.id, valueType);
        break;
      case "ch_one":
        this.updateData(location, "ch_one", itemData.id, valueType);
        break;
      case "checkbox-exclude-others":
        if (location.field === "permissions" && isSelected) {
          return null;
        } else if (location.field === "permissions" && isSelected) {
          this.updateData(
            { id: location.id, field: "" },
            "checkbox-exclude-others",
            itemData.id,
            valueType
          );
        } else {
          this.updateData(
            location,
            "checkbox-exclude-others",
            itemData.id,
            valueType
          );
        }
        break;
      case "checkbox":
        this.updateData(location, valueType, itemData.id, !isSelected);
        break;
      default:
        this.updateData(location, valueType, itemData.id);
    }
  };

  returnPermissionsModal = () => () => {
    this.props.open(`Permissions-${this.props.location.id}`);
  };

  render() {
    const {
      isSelected,
      itemData,
      child,
      location,
      isEdited,
      noBoxes,
      readOnly,
      className, 
    } = this.props;
    const classState =
      (itemData.text === "Guam" &&
        location.page !== pageIndex.cmd &&
        location.page !== pageIndex.regs) ||
      (itemData.text === "Puerto Rico" && location.page === pageIndex.regs)
        ? " state-line"
        : "";
    return (
      <span
        style={child ? customRegionStyles : itemData.childrenStyles}
        className={
          (isSelected
            ? (noBoxes
                ? "list-nobox-item--selected"
                : "checklist-item--selected") + classState
            : noBoxes
            ? "list-nobox-item"
            : "checklist-item") +
          classState +
          (readOnly ? " default-cursor" : "")
          + (className ? " " + className : "")
        }
        onClick={readOnly ? null : this.updateDataValue}
      >
        {itemData.text}
        {itemData.type === "checkbox-exclude-others" &&
        isSelected &&
        location.field === "permissions" ? (
          <span className="permission-lvl-dashboard">
            | <span onClick={this.returnPermissionsModal()}>View Details</span>
            {isEdited ? (
              <span className="customized-level"> - Customized</span>
            ) : null}
          </span>
        ) : null}
      </span>
    );
  }

  static propTypes = {
    itemData: PropTypes.object,
    updateData: PropTypes.func,
    location: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    fieldId: PropTypes.string,
    child: PropTypes.bool,
    open: PropTypes.func,
    isEdited: PropTypes.bool,
    noBoxes: PropTypes.bool,
    readOnly: PropTypes.bool,
  };
}

export default CheckboxesList;



// WEBPACK FOOTER //
// ./src/components/FormComponents/CheckboxesList/CheckboxesList.js